import { useState } from "react";

interface ResponsiveImageProps {
  src: string;
  alt?: string;
  className?: string;
  type?: "profile" | "logo" | "gallery";
}

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  src,
  alt = "Imagen",
  className = "",
  type = "gallery",
}) => {
  const [error, setError] = useState(false);

  const handleError = () => setError(true);

  return (
    <div className={`flex justify-center items-center overflow-hidden bg-gray-100 aspect-[4/3] ${className}`} >
  
      {!error ? (
        <img
          src={src}
          alt={alt}
          onError={handleError}
          loading="lazy"
          className={`transition-opacity duration-300 ${
            type === "logo" ? "object-contain" : "object-cover"
          } w-full h-full`}
        />
      ) : (
        <img
          src="/img/placeholder.webp"
          alt="fallback"
          className="object-contain w-full h-full"
        />
      )}
    </div>
  );
};

export default ResponsiveImage;
